import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideLogoutModal } from 'redux/navigation'
import { logoutUser } from 'redux/user'
import { Button, Header, Modal } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { logoutModalVisible } = state.navigation
  return { logoutModalVisible }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logoutUser,
      hideLogoutModal,
      push,
    },
    dispatch
  )
}

class LogoutModal extends React.Component {
  render() {
    const { logoutUser, hideLogoutModal, logoutModalVisible, push } = this.props

    return (
      <Modal
        basic
        dimmer="blurring"
        size="small"
        open={logoutModalVisible}
        className="logout">
        <Header icon="unlock" content={I18n.t('login.logout_title')} />
        <Modal.Actions>
          <Button
            basic
            color="red"
            inverted
            onClick={hideLogoutModal}
            icon="remove"
            content={I18n.t('global.no')}
          />
          <Button
            basic
            color="green"
            inverted
            onClick={() => {
              hideLogoutModal()
              push('/de/storefront/home')
              logoutUser()
            }}
            icon="checkmark"
            content={I18n.t('global.yes')}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

LogoutModal = connect(mapStateToProps, mapDispatchToProps)(LogoutModal)
export default LogoutModal



// WEBPACK FOOTER //
// ./src/components/shared/Logout/LogoutModal.jsx